import t from"react";function r(r,e,o){if(!o)return null;const f=r.isHorizontal()?{[r.rtlTranslate?"right":"left"]:`${o.offset}px`}:{top:`${o.offset}px`};return e.filter(((t,r)=>r>=o.from&&r<=o.to)).map((e=>t.cloneElement(e,{swiper:r,style:f})))}export{r as renderVirtual};
//# sourceMappingURL=virtual.js.map
